<template>
  <import-tab>
    <template v-slot:form>
      <upload-devices-values @uploaded="onUpload" />
      <devices-values-import-popup
        :title="popupTitle"
        :isOpen="popupOpen"
        :info="popupData"
        @openChanged="popupOpen=$event"
      />
    </template>

    <template v-slot:history>
      <vs-table
        v-if="history"
        :data="history"
        max-items="5"
        pagination
        class="w-full"
        noDataText="История импорта пуста"
      >
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>Дата</vs-th>
          <vs-th>Автор</vs-th>
          <vs-th>Имя файла</vs-th>
          <vs-th>Скачать</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}" ref="content">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <feather-icon
                icon="CheckCircleIcon"
                svg-classes="text-success"
                title="Импорт завершен без ошибок"
                v-if="tr.log && tr.log.errors.length === 0"
              />
              <feather-icon
                icon="AlertTriangleIcon"
                svg-classes="text-danger"
                title="Импорт завершен неудачно"
                v-else-if="tr.log && tr.log.errors.length === tr.log.total_values"
              />
              <feather-icon
                icon="AlertCircleIcon"
                svg-classes="text-warning"
                title="Импорт завершен с ошибками"
                v-else
              />
            </vs-td>
            <vs-td>
              {{ tr.created_at | moment('DD.MM.YYYY HH:mm:ss') }}
            </vs-td>
            <vs-td>
              <span v-if="tr.user">{{ tr.user.name }}</span>
            </vs-td>
            <vs-td>
              {{ tr.name }}
            </vs-td>
            <vs-td>
              <a :href="tr.path | imgPath" :download="tr.name" target="_blank">
                <feather-icon icon="DownloadIcon" svg-classes="text-primary" class="cursor-pointer" />
              </a>
            </vs-td>
            <vs-td>
              <a href="#" @click.prevent="onOpenLog(tr.log)"
                 v-if="tr.log">подробнее</a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </template>
  </import-tab>
</template>

<script>
import DevicesValuesImportPopup from "../DevicesValuesImportPopup";
import UploadDevicesValues      from "../UploadDevicesValues";
import ImportTab                from "./ImportTab";

export default {
  name:       "ImportValues",
  components: { DevicesValuesImportPopup, UploadDevicesValues, ImportTab },
  props:      ['selectedHouseId'],
  data() {
    return {
      history: null,

      popupTitle: null,
      popupOpen:  null,
      popupData:  {},
    };
  },
  methods:    {
    onUpload( $event ) {
      this.popupTitle = 'Импорт показаний завершен';
      this.popupOpen = true;
      this.popupData = $event.info;
      this.loadHistory();
    },
    onOpenLog( log ) {
      this.popupTitle = "Информация о импорте";
      this.popupOpen = true;
      this.popupData = log;
    },
    loadHistory() {
      const params = { buildings_id: this.selectedHouseId };
      this.$http.get('/import/history/values', { params }).then(( { data: { files } } ) => {
        this.history = files;
      });
    },
    openDeviceImportHistoryMore( log ) {
      this.devicesPopupTitle = "Информация о импорте";
      this.devicesPopupOpen = true;
      this.devicesAnswer = log;
    },

  },
  mounted() {
    this.loadHistory();
  },
  watch:      {
    selectedHouseId() {
      this.loadHistory();
    },
  },
};
</script>

<style scoped>

</style>
